import EFPicture from 'elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

const ArrowIcon = () => (
    <svg className="arrow-pc" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none" aria-hidden="true">
        <path
            d="M10.2114 10.2109C17.8266 2.59571 30.1743 2.59571 37.7895 10.2109C45.4048 17.8262 45.4048 30.1738 37.7895 37.7891C30.1743 45.4043 17.8266 45.4043 10.2114 37.7891C2.59619 30.1738 2.59619 17.8262 10.2114 10.2109ZM35.6684 12.332C29.2248 5.88837 18.7762 5.88837 12.3325 12.332C5.88886 18.7757 5.88886 29.2243 12.3325 35.668C18.7762 42.1116 29.2248 42.1116 35.6684 35.668C42.1121 29.2243 42.1121 18.7757 35.6684 12.332ZM24.3657 14.8926C25.002 14.3623 25.9486 14.4479 26.479 15.084L33.1079 23.0391C33.5715 23.5953 33.5715 24.4047 33.1079 24.9609L26.479 32.916C25.9486 33.5522 25.002 33.6377 24.3657 33.1074C23.7295 32.577 23.644 31.6305 24.1743 30.9941L28.7524 25.5H16.0454C15.217 25.4999 14.5454 24.8284 14.5454 24C14.5454 23.1716 15.2171 22.5001 16.0454 22.5H28.7524L24.1743 17.0059C23.644 16.3695 23.7294 15.4229 24.3657 14.8926Z"
            fill="#83868A"
        />
    </svg>
);

const ArrowIconDown = () => (
    <svg className="arrow-h5" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
        <path
            d="M18.8943 5.10522C22.7019 8.91283 22.7019 15.0867 18.8943 18.8943C15.0867 22.7019 8.91284 22.7019 5.10523 18.8943C1.29762 15.0867 1.29762 8.91283 5.10523 5.10522C8.91284 1.29761 15.0867 1.29761 18.8943 5.10522ZM17.8337 17.8337C21.0556 14.6119 21.0556 9.38759 17.8337 6.16577C14.6119 2.94394 9.3876 2.94394 6.16578 6.16577C2.94395 9.38759 2.94395 14.6119 6.16578 17.8337C9.3876 21.0556 14.6119 21.0556 17.8337 17.8337ZM16.5535 12.1824C16.8186 12.5005 16.7758 12.9738 16.4578 13.239L12.4802 16.5535C12.2021 16.7852 11.7974 16.7852 11.5193 16.5535L7.54175 13.239C7.22366 12.9738 7.18091 12.5005 7.44605 12.1824C7.71124 11.8643 8.18452 11.8215 8.50269 12.0867L11.2498 14.3757L11.2498 8.02221C11.2498 7.60803 11.5856 7.27221 11.9998 7.27221C12.4139 7.27223 12.7497 7.60804 12.7498 8.02221L12.7498 14.3757L15.4968 12.0867C15.815 11.8215 16.2883 11.8642 16.5535 12.1824Z"
            fill="#83868A"
        />
    </svg>
);

export default function C1() {
    const { useLang, gtm } = useGlobal();
    const { t } = useLang('outdoorrecreation');

    const cards: any[] = [
        {
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1786949686238-jn6pme-compressed-Frame%202094654917.webp',
            title: t('secC_list1_title'),
            desc: t('secC_list1_desc'),
            link: t('secC_list1_link'),
            url: '#outdoor-recreation-G',
        },
        {
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1786949717520-370ny0-compressed-Frame%202094654917.webp',
            title: t('secC_list2_title'),
            desc: t('secC_list2_desc'),
            link: t('secC_list2_link'),
            url: '#outdoor-recreation-D',
        },
        {
            img: 'https://websiteoss.ecoflow.com/figma-uploads/1786949733648-a3j7uv-compressed-Frame%202094654917.webp',
            title: t('secC_list3_title'),
            desc: t('secC_list3_desc'),
            link: t('secC_list3_link'),
            url: '#outdoor-recreation-J',
        },
    ];

    return (
        <div id="outdoor-recreation-C" className={`outdoor-recreation-C1 ${css['outdoor-recreation-C1']}`}>
            <div className="content">
                <div className="header">
                    <p className="section-title">{t('secC_title')}</p>
                    <p className="section-desc">{t('secC_desc')}</p>
                </div>
                <ul className="card-box">
                    {cards.map((card: any, k: number) => (
                        <li className="card" key={k}>
                            <div className="card-media">
                                <div className="card-img">
                                    <EFPicture src={card.img} alt={card.title} />
                                </div>
                                {k < cards.length - 1 && (
                                    <span className="card-arrow">
                                        <ArrowIcon />
                                        <ArrowIconDown />
                                    </span>
                                )}
                            </div>
                            <div className="card-text">
                                <p className="card-title">{card.title}</p>
                                <p className="card-desc">{card.desc}</p>
                                <a
                                    href={card.url}
                                    className="card-link"
                                    onClick={() =>
                                        gtm.push({
                                            event: 'uaEvent',
                                            event_name: 'activity_preview',
                                            button_name: card.link,
                                        })
                                    }
                                >
                                    <span>{card.link}</span>
                                </a>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
